import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
//import { LocalStorageService, SessionStorageService } from "angular-web-storage";
import { User } from "../../_models/user";
import { Caller } from "../../_models/caller";
import { Subject } from "rxjs";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router } from '@angular/router';
import { AlertService } from '../../_services/alert.service';
import { saveAs } from 'file-saver';
import { ExcelServiceService } from '../../_models/excel-service.service';

@Component({
  selector: 'app-drivers-list',
  templateUrl: './drivers-list.component.html',
  styleUrls: ['./drivers-list.component.css']
})
export class DriversListComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  driversList: any;
  tabClicked: string = "all";
  errorMessage: string;
  checkedList: any;
  masterSelected: boolean = false;
  previousStatus = '';
  driverStatus: any = 'ALL';
  totalRecords: number;
  userDrop2: any = 'ALL';
  constructor(private alertService: AlertService, private excelService: ExcelServiceService, private api: ApiIntegration, private g: Globals, private http: HttpClient, public user: User, private router: Router) {
    this.g.page = "Drivers List";
    this.populateTabData('all', "ALL");
  }

  populate(orderChange) {
    this.api.getShiftDriversList("1", orderChange).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.driversList = data.driversData;
    }, err => {
      this.g.loaderDisplay = "";

      this.alertService.error('Error', err);
    });
  }

  ngOnInit() { }

  checkUncheckAll() {
    for (var i = 0; i < this.driversList.length; i++) {
      this.driversList[i].isSelected = this.masterSelected;
    }
    this.getCheckedShipList();
  }

  selectShip(sl) {
    this.getCheckedShipList();
  }

  getCheckedShipList() {
    this.checkedList = [];
    for (var i = 0; i < this.driversList.length; i++) {
      if (this.driversList[i].isSelected) {
        this.checkedList.push(this.driversList[i]['id']);
      }
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }

  exportToXLSX() {
    this.excelService.exportAsExcelFile(this.driversList, 'sample');
  }

  editDriver(driversList) {
    this.checkedList = [];
    let i = 0;
    let ohid;
    for (let driver of driversList) {
      if (driver.isSelected) {
        i = i + 1;
        ohid = driver.id;
      }
    };
    if (i === 1) {
      this.router.navigate(['/admin/editDrive/' + ohid]);
    } else {
      this.errorMessage = "Can not Edit multiple Invoice at once. Please select one at a time";
    }
  }
  populateTabData(triggered, driverStatus) {
    this.tabClicked = triggered;
    this.driverStatus = driverStatus;
    if (!this.previousStatus) {
      this.getShiftDriversList(driverStatus);
    } else {
      this.rerender();
    }

  }
  getShiftDriversList(status) {
    this.dtOptions = {
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by Driver Name'
      },
      ajax: (dataTablesParameters: any, callback) => {
        if (this.previousStatus !== this.driverStatus) {
          dataTablesParameters.start = 0;
          this.previousStatus = this.driverStatus;
        }
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        let apiMethod = 'api/getShiftDriversList';
        let query: any = {
          status: this.driverStatus,
          organizationId: 1,
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        if (this.user.role == 'ACCOUNT_OWNER' || this.user.role === "ROLE_USER") {
          query.accountOwnerId = this.user.accountOwnerId;
        }
        this.g.loaderDisplay = "display";
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.driversList = resp.driversData;
            this.totalRecords = resp.noOfRecords;
            this.g.loaderDisplay = "";
            this.driversList.forEach((s) => {
              s['isSelected'] = false;
            });
            callback({
              recordsTotal: resp.noOfRecords,
              recordsFiltered: resp.noOfRecords
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    }
  }
  tabChange() {
    this.checkedList = [];
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

  changeStatus(n) {
    this.g.loaderDisplay = "display";
    if (n.status == "ACTIVE") {
      n.status = "IN_ACTIVE";
    } else {
      n.status = "ACTIVE";
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/updateStatus', {
      "id": n.id,
      "status": n.status
    }, { headers: header1 }).subscribe(data => {
      if (data['code'] == 200) {
        this.alertService.success('Driver', 'Status Updated Successfully');

      } else {
        this.alertService.error('Error', data['message']);
      }
      this.g.loaderDisplay = "";
      let index = this.driversList.indexOf(n);
      this.driversList.splice(index, 1);
      this.rerender();

    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
      });

  }
}
